// extracted by mini-css-extract-plugin
module.exports = {"Statistics":"Statistics_Statistics__3Ncd-","grid":"Statistics_grid__3PQzc","maxH700":"Statistics_maxH700__2E3Qn"};